export default __webpack_public_path__ + "img/WB_NB_250MA_EF.1ad552575c4fc2dc3aac226fde091e0a.jpg";